/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_DescriptionInputs */

const en_pricing_description = /** @type {(inputs: Pricing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simple, transparent pricing with no hidden fees`)
};

const es_pricing_description = /** @type {(inputs: Pricing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precios simples y transparentes sin costes ocultos`)
};

/**
* | output |
* | --- |
* | "Simple, transparent pricing with no hidden fees" |
*
* @param {Pricing_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_description = /** @type {((inputs?: Pricing_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_description(inputs)
	return es_pricing_description(inputs)
});